import {Col} from '@modifi/ui'
import styled from 'styled-components'

export const StyledCol = styled(Col)`
  text-align: center;
`
